<template>
  <div class="_home">
    <slider :homeSetting="homeSetting"></slider>

    <company :homeSetting="homeSetting" :companies="companies"></company>

    <discover :cities="cities" :homeSetting="homeSetting" v-if="homeSetting.show_studios_cities == 1"/>

    <!-- most ordered -->
    <spaces redirect_link="/spaces?type=most_ordered" :studios="mostOrderedSpaces"
            :studio_title="homeSetting.studios_most_ordered_title" :label_div="$t('most-ordered')"/>

    <div class="bg-black">
      <div class="container">
        <div class="row align-items-center seen-banner">
          <div class="col-12 col-lg-5 order-3 order-lg-1">
            <div class="seen-banner-info" v-if="homeSetting.first_banner_title">
              <h1>{{ homeSetting.first_banner_title }}</h1>
              <p v-html="homeSetting.first_banner_description"></p>
              <a href="/spaces" class="btn btn-light seen-banner-btn">
                {{ $t('start-now') }}
              </a>
            </div>
            <div v-else class="py-16">
              <v-skeleton-loader class="bg-transparent mb-3" type="article" width="500"></v-skeleton-loader>
              <v-skeleton-loader type="button" width="500"></v-skeleton-loader>
            </div>
          </div>
          <div class="col-12 col-lg-2 order-2 order-lg-2"></div>
          <div class="col-12 col-lg-5 order-1 order-lg-3">
            <img v-if="siteData.first_banner_url" :src="siteData.first_banner_url" alt="about image" class="img-fluid"/>
            <v-skeleton-loader v-else class="me-auto" type="image" width="500"></v-skeleton-loader>
          </div>
        </div>
      </div>
    </div>

    <classification :studioCategories="studioCategories" :homeSetting="homeSetting"
                    v-if="homeSetting.show_studios_categories == 1"/>

    <features :homeSetting="homeSetting"></features>

    <!-- special spaces -->
    <spaces redirect_link="/spaces" :studios="specialStudios" :studio_title="homeSetting.studios_special_title"
            :studio_description="homeSetting.studios_special_description" :label_div="$t('spaces')"
            v-if="homeSetting.show_studios_special == 1"/>

    <div class="container">
      <div class="seen-app">
        <div class="seen-app-info">
          <img :src="siteData.app_mobile_image_url ?? '/img/newMainPage/app-links.png'" alt="app links image"
               class="img-fluid app-links-img"/>

          <div class="d-inline-block text-center">
            <h1>{{ $t('musawir-app') }}</h1>
            <h1 :class="(social.app_store || social.google_play) ? 'mb-8 mb-md-16' : ''">قريباً SOON</h1>
          </div>
          <div class="app-links" v-if="social.app_store || social.google_play">
            <p>{{ $t('download-our-app') }}</p>
            <div
                class="row align-items-center justify-content-center justify-content-xl-start column-gap-4 column-gap-md-0">
              <div class="col-12 col-md-auto" v-if="social.app_store">
                <a :href="social.app_store" target="_blank">
                  <img src="/img/newMainPage/appstore.png" alt="app store image" class="img-fluid"/>
                </a>
              </div>
              <div class="col-12 col-md-auto" v-if="social.google_play">
                <a :href="social.google_play" target="_blank">
                  <img src="/img/newMainPage/googleplay.png" alt="google play image" class="img-fluid"/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    <articles :homeSetting="homeSetting" :siteData="siteData"></articles>-->

    <rates :homeSetting="homeSetting" :rates="rates" v-if="homeSetting.show_services == 1"></rates>

    <LightBox :media="explanations" v-if="Openlightbox && explanations.length" @onClosed="closeLightbox"
              :showCaption="true" :showThumbs="false"></LightBox>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import slider from "@/components/home/slider.vue";
import company from "@/components/home/company.vue";
import discover from "@/components/home/discover.vue";
import spaces from "@/components/home/spaces.vue";
import classification from "@/components/home/classification.vue";
import features from "@/components/home/features.vue";
import articles from "@/components/home/articles.vue";
import rates from "@/components/home/rates.vue";
import LightBox from 'vue-it-bigger';

import('vue-it-bigger/dist/vue-it-bigger.min.css');

export default {
  name: "index",
  components: {
    slider,
    company,
    discover,
    spaces,
    classification,
    features,
    articles,
    rates,
    LightBox
  },
  data() {
    return {
      Openlightbox: true,
    };
  },
  computed: {
    ...mapGetters("home", [
      'getCompanies',
      "getCatg",
      "getStudios",
      "getMostOrderedSpaces",
      "getCities",
      "getSetting",
      "getSiteData",
      "getSocial",
      "getRates",
      "getExplanations",
    ]),
    companies() {
      return this.getCompanies;
    },
    studioCategories() {
      return this.getCatg;
    },
    specialStudios() {
      return this.getStudios;
    },
    mostOrderedSpaces() {
      return this.getMostOrderedSpaces;
    },
    cities() {
      return this.getCities;
    },
    homeSetting() {
      return this.getSetting;
    },
    siteData() {
      return this.getSiteData;
    },
    social() {
      return this.getSocial;
    },
    rates() {
      return this.getRates;
    },
    explanations() {
      return this.getExplanations;
    },
  },
  mounted() {
    this.$store.dispatch("home/fetchSiteData");
  },
  methods: {
    closeLightbox() {
      this.Openlightbox = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.seen-banner {
  padding: 54px 0;

  .seen-banner-info {
    color: #F4F4F4;
    text-align: start;

    h1 {
      font-size: 48px;
      font-weight: 600;
      line-height: 56px;
    }

    p {
      font-size: 18px;
      padding: 40px 0;
      font-style: normal;
      font-weight: 500;
      line-height: 26px;
    }

    .seen-banner-btn {
      border-radius: 8px;
      background: #F4F4F4;
      box-shadow: 0 1px 2px 0 rgba(13, 13, 18, 0.06);
      color: #1E1E1E;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 155%; /* 24.8px */
      min-width: 200px;
    }
  }

  img {
    width: 100%;
    max-height: 400px;
    object-fit: contain;
  }
}

@media (max-width: 575px) {
  .seen-banner {
    padding: 25px 0;

    .seen-banner-info {
      h1 {
        font-size: 20px;
        line-height: 28px;
      }

      p {
        font-size: 14px;
        padding: 10px 0;
        line-height: 20px;
      }

      .seen-banner-btn {
        color: #1E1E1E;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 155%; /* 24.8px */
        min-width: 100%;
      }
    }
  }
}

.seen-app {
  position: relative;
  margin: 50px auto 75px auto;

  .seen-app-info {
    background: linear-gradient(232deg, #000 4%, #1F1F1F 44%, #000 97%);
    border-radius: 24px;
    padding: 100px;
    text-align: start;
    color: #F4F4F4;

    h1 {
      font-size: 40px;
      font-style: normal;
      font-weight: 600;
      line-height: 48px;
    }

    .app-links {
      p {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
      }

      img {
        width: 165px;
        height: 48px;
        object-fit: contain;
      }
    }
  }

  .app-links-img {
    position: absolute;
    top: -70px;
    left: -35px;
  }

  @media (max-width: 1263px) {
    margin: 24px auto;

    .seen-app-info {
      padding: 24px;
      text-align: center;
      border-radius: 16px;

      h1 {
        font-size: 24px;
        line-height: 32px;
        font-weight: 500;
      }

      .app-links {
        img {
          width: 165px;
          height: 48px;
          object-fit: contain;
        }
      }
    }
    .app-links-img {
      position: relative;
      top: unset;
      left: unset;
      margin: 0 0 32px 0;
    }
  }

  @media (max-width: 768px) {
    .seen-app-info {
      .app-links {
        p {
          margin-bottom: 24px !important;
        }

        img {
          width: 100%;
          height: 60px;
        }
      }
    }
  }
}

[lang='en'] .app-links-img {
  left: unset;
  right: -35px;
}

@media (max-width: 1023px) {
  [lang='en'] .app-links-img {
    position: relative;
    top: unset;
    left: unset;
    right: unset;
    margin: 36px 0;
  }
}

span {
  strong {
    font-weight: bold;
    background: #000;
    color: #fff;
    padding: 6px 10px 10px 14px;
    margin: 0 5px;
  }
}
</style>
<style>
.vib-hidden {
  opacity: 1;
}

.vib-close {
  right: auto;
  left: 0;
}

.label-div {
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #FEFEFE;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 24px;
}

.label-div i {
  font-size: 8px;
}
</style>
